<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
    <v-layout column right floating class="fab-container" style="z-index: 1"> </v-layout>
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";
import { PROCESO_SELECT, SERVICIO_SELECT } from "@/constants/bitacoraGeolocalizacion";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        vendor: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , proceso: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , servicio: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        fecha: []
        , proceso: []
        , servicio: []
        , direccion: []
        , altura: []
        , vendor: []
        , se: []
        , username: []
      }
      , options: [
        {
          code: "fecha"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.fecha")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "proceso"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.proceso")
          , icon: "fas fa-text-height"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "servicio"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.servicio")
          , icon: "fas fa-clipboard-list"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "direccion"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.direccion")
          , icon: "fas fa-font"
          , type: "text"
          , selected: ""
          , disabled: false
        }
        , {
          code: "altura"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.altura")
          , icon: "fas fa-hashtag"
          , type: "text"
          , selected: ""
          , disabled: false
        }
        , {
          code: "vendor"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.vendor")
          , icon: "fas fa-hand-holding-usd"
          , type: "select"
          , selected: {}
          , disabled: this.$store.getters.getUserData.tipoUsuario != "ADMINISTRADOR"
        }
        , {
          code: "se"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.se")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "username"
          , name: this.$t("view.bitacoras.geolocalizacion.filtros.username")
          , icon: "fas fa-font"
          , type: "text"
          , selected: ""
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectVendor();
        this.loadSelectProceso();
        this.loadSelectServicio();
        if (this.select.vendor.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectVendor() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.select.vendor.filteredList = vendorList || [];
      this.select.vendor.completeList = vendorList || [];
    }
    , async loadSelectProceso() {
      this.select.proceso.filteredList = PROCESO_SELECT || [];
      this.select.proceso.completeList = PROCESO_SELECT || [];
    }
    , async loadSelectServicio() {
      this.select.servicio.filteredList = SERVICIO_SELECT || [];
      this.select.servicio.completeList = SERVICIO_SELECT || [];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/bitacoras/geolocalizacion/Filters.vue